import { render, staticRenderFns } from "./SliderLayout.vue?vue&type=template&id=e1a94c90&"
import script from "./SliderLayout.vue?vue&type=script&lang=js&"
export * from "./SliderLayout.vue?vue&type=script&lang=js&"
import style0 from "./SliderLayout.vue?vue&type=style&index=0&id=e1a94c90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports